// JavaScript source code
import React from "react";
import '../css/Experience.css';

function MyExperiences() {
    return (
        <div>
            <div class="exp">
                <div class="flex1">
                    <h3>Cisco Systems</h3>
                    <h3> June 2021 - September 2021 </h3>
                </div>
                <h3> Undergraduate Technical Intern </h3>
                <p> Having had the experience of a previous internship, I felt confident and well equipped going into this internship but the idea of a virtual internship was daunting.
                    Going into this internship, I went in with the goal of improving myself in areas - such as networking and connecting with my colleagues, asking for help and taking a more active role in picking up work - that I felt I didn't perform as well during my first internship.
                    The ease of access to fellow interns, mentors and colleagues for ideas and advice were a huge part of my first internship and not being in the office was going to be a challenge.
                    I had a great team and system set up for my virtual internship and I was able to make the most out of it.
                    I took on 3 projects each of which had me operate under a different capcity. In the capacity of a project manager role, I lead a team of 4 interns on a project to build a proof of concept to demonstate a crowdsourcing platform which could be used by the planning team on Cisco's supply chain to increase forecasting accuracy.
                    On another project I defined and built the capabilities of an email automaiton system which would be tiggered by a business event primarily utilizing MIME messaging through Java which was pushed into final production.
                    Lastly I worked on the frontend development under two software engineers of a web application by making it responsive and adding other functionalities.
                </p>
            </div>

            <div class="exp">
                <div class="flex1">
                    <h3>Cisco Systems</h3>
                    <h3> June 2019 - September 2019 </h3>
                </div>
                <h3> Undergraduate Technical Intern </h3>
                <p>Going into my first technical internship I wasn't sure what to expect and decideed to do my best and absorb everything that I could from this experience.
                    Speaking to many managers, one of the things that I picked up was the importance of software engineers knowing why they are working towards a certain goal rather than just focusing on the how. As a result I decided to ty to master the domain I was working in which was the Supply Chain side of Cisco.
                    I made it a point to speak to colleagues on the business side of the supply chain team to understand how Cisco's supply chain works.
                    Additionally specialized in the font end development of a web app dashboard using AngularJS and Spring MVC frameworks. Through the development of this page I spoke to several UI/UX designers to learn how I could improve customer interactions with my webpage.
                    One big skill, I took fom this internship were the soft skills and the nuances of working within a team.

                </p>
            </div>

            <div class="exp">
                <div class="flex1">
                    <h3>Santa Clara University</h3>
                    <h3> December 2019 - Present </h3>
                </div>
                <h3> Student Ambassador School of Engineering - Tour Guide </h3>
                <p>Over the course of the past 2 years, I have served as a tour guide for the school of engineering here at SCU, guiding prospective high school students through the college application process.
                    It was a challenge at first as the idea of talking in front of 20+ people pitching my university while also trying my best to not fall down while walking backwards was daunting, however over time I was able to confidently lead tours.
                    This was an interesting experience as for the first year we had to lead virtual tours online due to the pandemic which required us to have to learn a whole new set of skills.

                </p>
            </div>

            <div class="exp">
                <div class="flex1">
                    <h3>Santa Clara University</h3>
                    <h3> June 2021 - Present </h3>
                </div>
                <h3> Student Ambassador School of Engineering - Peer Advisor </h3>
                <p> During my senior year here at SCU, I have served as a peer advisor helping 30 freshmen in the school of engineering by guiding them through their first year and being there point of contact fo any issues/questions.
                    It has required me to learn to manage my time better as I was responsible for leading 30 students and communicating relevant information to ensure they reach certain milestones by specific timelines.
                </p>
            </div>

            <div class="exp">
                <div class="flex1">
                    <h3>San Francisco 49ers</h3>
                    <h3> June 2021 - Present </h3>
                </div>
                <h3> Guest Representative Services </h3>
                <p> During 49ers gamedays at Santa Clara I aided the organization by aiding the fans to ensure they have the best experience as possible.
                    While I do get a great view of every game I have also have had to put myself in uncomfortable situations when fans don't abide to stadium rules which has taught me how I myself react to certain situations and how I could deal with conflict better
                </p>
            </div>

            <div class="exp">
                <div class="flex1">
                    <h3>Commuter Student Union</h3>
                    <h3> August 2020 - Present </h3>
                </div>
                <h3> Club President & Treasurer</h3>
                <p> Over the course of 2 years I have served on the board of the commuter student union which is designed to ensure students who don't live on campus to have a sense of community at college.
                    The complexity of planning events has been a great learning tool as the pressure of promising free food to college students and not delivering is hard to replicate
                </p>
            </div>

            <div class="exp">
                <div class="flex1">
                    <h3>Blach Middle School</h3>
                    <h3> October 2019 - December 2019 </h3>
                </div>
                <h3> Flag Football Head Coach </h3>
                <p>Over the course of 4 months I worked with a group of middle school boys at Blach Middle School in Los Altos in coaching their flag football team. It was a great experience and I had a lot of fun working with and learning from the kids I was working with about creating a fun but productive environment
                </p>
            </div>
            
        </div>
        );

}
export default MyExperiences